import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Page, Card, TextField, Button, Text, BlockStack } from '@shopify/polaris';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function InstallPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [shop, setShop] = useState(searchParams.get('shop') || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInstall = async () => {
    if (!shop) {
      setError('Please enter your shop domain');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.get(`${API}/install`, {
        params: { shop }
      });

      if (response.data.auth_url) {
        window.location.href = response.data.auth_url;
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Installation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page>
      <div style={{ maxWidth: '500px', margin: '100px auto' }}>
        <Card>
          <BlockStack gap="400">
            <Text variant="headingLg" as="h1">Install Australia Post Shipping</Text>
            <Text variant="bodyMd" as="p" tone="subdued">
              Enter your Shopify store domain to install the app
            </Text>
            <TextField
              label="Shop Domain"
              value={shop}
              onChange={setShop}
              placeholder="your-store.myshopify.com"
              autoComplete="off"
              error={error}
            />
            <Button
              primary
              onClick={handleInstall}
              loading={loading}
              fullWidth
            >
              Install App
            </Button>
          </BlockStack>
        </Card>
      </div>
    </Page>
  );
}

export default InstallPage;